import React, { useState } from 'react';
import { GiHamburgerMenu } from 'react-icons/gi';

import './App.css';
import About from './routes/About/About.js';
import Projects from './routes/Projects/Projects.js';
import Technologies from './routes/Technologies/Technologies.js';
import Contact from './routes/Contact/Contact.js';
import Navbar from './components/Navbar/Navbar.js';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  const [navbarModal, setNavbarModal] = useState(true);

  const handleNavbar = () => {
    setNavbarModal(!navbarModal);
  };

  return (
    <div>
      <Router>
        {navbarModal && (
          <header>
            <Navbar />
          </header>
        )}
        <button className="btnCloseNavbar" onClick={() => handleNavbar()}>
          <GiHamburgerMenu />
        </button>
        <Routes>
          <Route index path="/" element={<About />} />
          <Route path="projects" element={<Projects />} />
          <Route path="technologies" element={<Technologies />} />
          <Route path="contact" element={<Contact />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
